var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_flip_to_front") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "7.27272727e-05 0 7.27272727 0 7.27272727 7.27272727 7.27272727e-05 7.27272727"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v1-Final",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Video-Patient-Profile-page-:-Consult-Expanded-:-In-Conference-waiting-room",
    transform: "translate(-1200.000000, -128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Waiting-Room",
    transform: "translate(949.000000, 86.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "enlarge",
    transform: "translate(245.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-expand-video-icon",
    transform: "translate(6.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "expand-video-icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(8.727273, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45025455,7.27272727 L0.822618182,7.27272727 C0.368072727,7.27272727 7.27272727e-05,6.90472727 7.27272727e-05,6.45018182 L7.27272727e-05,0.822545455 C7.27272727e-05,0.368 0.368072727,0 0.822618182,0 L6.45025455,0 C6.9048,0 7.2728,0.368 7.2728,0.822545455 L7.2728,6.45018182 C7.2728,6.90472727 6.9048,7.27272727 6.45025455,7.27272727",
    id: "Fill-1",
    fill: "#4D4D4D",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.7229818,16 L0.822618182,16 C0.368072727,16 7.27272727e-05,15.632 7.27272727e-05,15.1774545 L7.27272727e-05,2.27709091 C7.27272727e-05,1.82254545 0.368072727,1.45454545 0.822618182,1.45454545 L7.17752727,1.45454545 C7.22989091,1.45454545 7.2728,1.49745455 7.2728,1.54981818 L7.2728,2.81381818 C7.2728,2.86618182 7.22989091,2.90909091 7.17752727,2.90909091 L1.54989091,2.90909091 C1.4968,2.90909091 1.45461818,2.952 1.45461818,3.00436364 L1.45461818,14.4501818 C1.45461818,14.5025455 1.4968,14.5454545 1.54989091,14.5454545 L12.9957091,14.5454545 C13.0480727,14.5454545 13.0909818,14.5025455 13.0909818,14.4501818 L13.0909818,8.82254545 C13.0909818,8.77018182 13.1331636,8.72727273 13.1862545,8.72727273 L14.4502545,8.72727273 C14.5026182,8.72727273 14.5455273,8.77018182 14.5455273,8.82254545 L14.5455273,15.1774545 C14.5455273,15.632 14.1775273,16 13.7229818,16",
    id: "Fill-4",
    fill: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(2.909091, 7.272727)",
    fill: "#4D4D4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.45454545 L0,5.72290909 C0,5.77527273 0.0429090909,5.81818182 0.0952727273,5.81818182 L4.36363636,5.81818182",
    id: "Fill-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.15592727,1.69032727 L1.69047273,5.15650909 C1.65338182,5.19287273 1.59374545,5.19287273 1.55592727,5.15650909 L0.662109091,4.26196364 C0.625018182,4.22487273 0.625018182,4.16450909 0.662109091,4.12814545 L4.12756364,0.661963636 C4.16465455,0.624872727 4.22501818,0.624872727 4.26210909,0.661963636 L5.15592727,1.55578182 C5.19301818,1.59287273 5.19301818,1.65323636 5.15592727,1.69032727",
    id: "Fill-9"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatExpand);
export default __webpack_public_path__ + "static/media/chatExpand.353b0f6c5958547e4337e667feaa20dd.svg";
export { ForwardRef as ReactComponent };